import { hash } from 'ohash';

/**
 * Returns an opaque project scoped key that can be used for persisting local storage data.
 */
export function useProjectScopedKey(key?: string) {
	// TODO actually use current project uuid as a prefix

	if (!key) {
		return 'project';
	}

	// TODO should this hash the whole identifier, or only the key after the project UUID?
	// TODO should we disable hashing in dev-mode for easier debugging?
	return `project:${hash(key)}`;
}
